import { Component, computed, inject, input, model, output, ChangeDetectionStrategy } from '@angular/core';
import { IMicaChatTelefonoData } from '@core/interfaces/entidades/telefono.entidad';
import { EvolutionApiService } from '@core/services/api/evolution-api.service';
import { MicaChatService } from '@shared/services/mica-chat.service';

type TVista = 'chats' | 'flujos' | 'campanas' | 'configuracion';

@Component({
  selector: 'app-mica-chat-header',
  imports: [],
  templateUrl: './mica-chat-header.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mica-chat-header.css',
})
export class MicaChatHeader {
  private readonly evoApi = inject(EvolutionApiService);
  readonly micaChatService = inject(MicaChatService);

  telefonos = input<IMicaChatTelefonoData[]>([]);
  vistaActiva = model<TVista>('chats');
  telefonoCambiado = output<IMicaChatTelefonoData | null>();

  telefonoComprobantes = computed(() => {
    return this.telefonos().find((t) => t.usar_para_comprobantes) || null;
  });

  onChangeTelefono(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const telefonoId = Number(selectElement.value);
    const telefonoSeleccionado = this.telefonos().find((t) => t.id === telefonoId) || null;
    this.telefonoCambiado.emit(telefonoSeleccionado);
    this.micaChatService.setTelefonoSeleccionado(telefonoSeleccionado);
    if (telefonoSeleccionado?.proveedor === 'NO_OFICIAL') {
      this.verificarEstado(telefonoSeleccionado.id);
    } else {
      this.micaChatService.clearEstadoConexion();
    }
  }

  seleccionarVista(vista: TVista) {
    this.vistaActiva.set(vista);
  }

  get estadoConexion() {
    return this.micaChatService.estadoConexion;
  }

  getConnectionStatusColor(): string {
    const estado = this.micaChatService.estadoConexion()?.estado;
    if (estado === 'conectado') return 'bg-emerald-500';
    if (estado === 'conectando') return 'bg-yellow-500';
    return 'bg-red-500';
  }

  getConnectionStatusText(): string {
    const estado = this.micaChatService.estadoConexion()?.estado;
    if (estado === 'conectado') return 'Conectado';
    if (estado === 'conectando') return 'Conectando...';
    return 'Desconectado';
  }

  private verificarEstado(telefonoId: number): void {
    this.evoApi.obtenerEstadoConexion(telefonoId).subscribe({
      next: (estado) => this.micaChatService.setEstadoConexion(estado),
      error: () => this.micaChatService.clearEstadoConexion(),
    });
  }
}
